export default "__VITE_ASSET__BsCQqzzn__"